import React from 'react';

const ErrorState = ({ error, onRetry }) => {
  return (
    <main>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <i className="iconoir-warning-triangle f-s-48 text-danger mb-3"></i>
                <h5 className="text-danger">{error}</h5>
                <button 
                  onClick={onRetry} 
                  className="btn btn-primary mt-3"
                  style={{ minWidth: '120px', width: 'fit-content', margin: '0 auto' }}
                >
                  Retry
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ErrorState;